import { getRuntimeTheme } from '../runtimeEnv'

const LEGISLATION = {
  bc: {
    name: 'FIPPA',
    fullName: 'Freedom of Information and Protection of Privacy Act',
    redactionExample: 'FIPPA s. 22(1)'
  },
  saskatchewan: {
    name: 'LA FOIP',
    fullName: 'Local Authority Freedom of Information and Protection of Privacy Act',
    redactionExample: 'LA FOIP s. 28(1)'
  }
}

export function getLegislation(themeName = getRuntimeTheme()) {
  return themeName === 'saskatoonfoi' ? LEGISLATION.saskatchewan : LEGISLATION.bc
}
